import { FC } from 'react';
import { styled } from '@mui/material/styles';
import { CircularProgress, CircularProgressProps, SxProps, Theme } from '@mui/material';


interface LoadingIndicatorProps extends CircularProgressProps {
  loading: Boolean;
  sx?: SxProps<Theme>
}

const LoadingIndicator: FC<LoadingIndicatorProps> = ({ loading, sx = [], ...props }: LoadingIndicatorProps) => {
  return (
    (loading ?
      (
        <>
          <svg width="0" height="0">
            <linearGradient id="linearColors" x1="0" y1="0" x2="1" y2="1">
              <stop offset="5%" stopColor="#931216"></stop>
              <stop offset="25%" stopColor="#E20B23"></stop>
              <stop offset="40%" stopColor="#FF8230"></stop>
              <stop offset="60%" stopColor="#931216"></stop>
              <stop offset="80%" stopColor="#E20B23"></stop>
              <stop offset="100%" stopColor="#FF8230"></stop>
            </linearGradient>
          </svg>
          <MuiCircularProgress
            {...props}
            sx={[
              {
                'svg circle': {
                  stroke: 'url(#linearColors)'
                }
              },
              ...(Array.isArray(sx) ? sx : [sx])
            ]}
          />
        </>
      )
      :
      (
        null
      )

    )
  )
};

const MuiCircularProgress = styled(CircularProgress)((props) => {
  return {
    color: 'red'
  }
});

export default LoadingIndicator;
